export default {
  title: "وحدات القياس",
  subtitle: "إدارة وحدات القياس",
  createTitle: "إنشاء وحدة قياس",
  createSubtitle: "إضافة وحدة قياس جديدة",
  editTitle: "تعديل وحدة القياس",
  editSubtitle: "تحديث تفاصيل وحدة القياس",
  
  breadcrumbs: {
    measurementUnits: "وحدات القياس",
    create: "إنشاء",
    edit: "تعديل"
  },
  
  table: {
    name: "الاسم",
    symbol: "الرمز",
    type: "النوع",
    conversionFactor: "معامل التحويل",
    isDefault: "افتراضي",
    actions: "الإجراءات"
  },
  
  fields: {
    name: "الاسم",
    symbol: "الرمز",
    type: "النوع",
    conversionFactor: "معامل التحويل إلى الوحدة الأساسية",
    isDefault: "تعيين كوحدة افتراضية"
  },
  
  types: {
    length: "الطول",
    weight: "الوزن"
  },
  
  placeholders: {
    name: "أدخل اسم الوحدة (مثل: كيلوجرام)",
    symbol: "أدخل رمز الوحدة (مثل: كجم)",
    conversionFactor: "أدخل معامل التحويل إلى الوحدة الأساسية"
  },
  
  validation: {
    nameRequired: "الاسم مطلوب",
    symbolRequired: "الرمز مطلوب",
    conversionFactorRequired: "معامل التحويل يجب أن يكون أكبر من 0",
    fillAllFields: "يرجى ملء جميع الحقول المطلوبة"
  },
  
  messages: {
    fetchError: "خطأ في جلب وحدات القياس",
    createSuccess: "تم إنشاء وحدة القياس بنجاح",
    createError: "خطأ في إنشاء وحدة القياس",
    updateSuccess: "تم تحديث وحدة القياس بنجاح",
    updateError: "خطأ في تحديث وحدة القياس",
    deleteSuccess: "تم حذف وحدة القياس بنجاح",
    deleteError: "خطأ في حذف وحدة القياس",
    deleteConfirm: "هل أنت متأكد من حذف وحدة القياس هذه؟",
    noMeasurementUnits: "لا توجد وحدات قياس",
    loading: "جاري تحميل وحدات القياس..."
  },
  
  buttons: {
    create: "إنشاء وحدة",
    creating: "جاري الإنشاء...",
    update: "تحديث الوحدة",
    updating: "جاري التحديث...",
    cancel: "إلغاء"
  },
  
  addNew: "إضافة وحدة جديدة",
  
  help: {
    conversionFactor: "المعامل لتحويل هذه الوحدة إلى الوحدة الأساسية من نفس النوع. على سبيل المثال، إذا كانت الوحدة الأساسية للوزن هي الكيلوجرام، فإن 1 جرام = 0.001 كجم، لذا معامل التحويل للجرام سيكون 0.001.",
    defaultUnit: "الوحدة الافتراضية تُستخدم كأساس للتحويلات ضمن نفس نوع القياس."
  }
};
